import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8b88a2ac")

_pushScopeId("data-v-8b88a2ac")
const _hoisted_1 = { class: "flex z-20 content-center items-center" }
const _hoisted_2 = { class: "font-semibold self-center mr-10 text-20px whitespace-no-wrap text-black-lp-200 capitalize" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Search = _resolveComponent("Search")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_generate_csv = _resolveComponent("generate-csv")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Notification = _resolveComponent("Notification")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      id: "shortland",
      class: ["bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full", _ctx.isSidebarAndBreadcrumbV2 ? 'pt-4' : 'pt-8']
    }, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_Header, { class: "items-center" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.getTitle), 1),
            _createVNode(_component_Search, {
              class: "self-center shortland-search",
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              placeholder: _ctx.$t('shortland.searchPlaceholder')
            }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
            _createVNode(_component_time_range_picker, {
              default: "custom",
              class: "mr-4",
              startDate: _ctx.startDate,
              endDate: _ctx.endDate,
              onSelect: _ctx.setDateRange,
              showOptions: _ctx.timeRangeOptions,
              minDate: _ctx.minDate,
              maxDate: _ctx.maxDate,
              onDayClick: _ctx.setDay,
              isOptionDisabled: !_ctx.isStartDate,
              onCancelRangePick: _ctx.cancelRangePick
            }, null, 8, ["startDate", "endDate", "onSelect", "showOptions", "minDate", "maxDate", "onDayClick", "isOptionDisabled", "onCancelRangePick"])
          ]),
          _createVNode(_component_generate_csv, {
            jsonData: _ctx.mappingCsv,
            outputFileName: _ctx.fileName,
            labels: _ctx.csvLabels,
            class: "justify-self-end",
            disabled: _ctx.isDownloadDisabled
          }, {
            default: _withId(() => [
              _createVNode(_component_lp_button, {
                disabled: _ctx.isDownloadDisabled,
                title: _ctx.$t('shortland.downloadButton'),
                textColor: "white"
              }, null, 8, ["disabled", "title"])
            ]),
            _: 1
          }, 8, ["jsonData", "outputFileName", "labels", "disabled"])
        ]),
        _: 1
      }),
      (_ctx.isError && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: _ctx.errorCause,
            onTryAgain: _ctx.fetchShortlandList
          }, null, 8, ["errorType", "onTryAgain"]))
        : (
        _ctx.shortlandList.length === 0 &&
          !_ctx.searchValue &&
          !_ctx.startDate &&
          !_ctx.endDate &&
          !_ctx.isLoading &&
          _ctx.pagination.page === 1
      )
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 1,
              data: _ctx.$t('shortland.title')
            }, null, 8, ["data"]))
          : (_openBlock(), _createBlock(_component_TableV2, {
              key: 2,
              columns: _ctx.columns,
              data: _ctx.shortlandList,
              loading: _ctx.isLoading,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
              totalColumnFreeze: 0,
              isRightFreeze: true,
              onRequest: _ctx.fetchShortlandList,
              errorCause: _ctx.errorCause,
              showRightShadow: "",
              autoHeight: ""
            }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause"]))
    ], 2),
    _createVNode(_component_Notification, {
      modelValue: _ctx.isUpdate,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isUpdate = $event)),
      onRefresh: _ctx.fetchShortlandList,
      timeout: _ctx.shortlandList.length ? 600 : 0
    }, null, 8, ["modelValue", "onRefresh", "timeout"])
  ], 64))
})